import { RootState } from "../../types";
import { createSlice } from "@reduxjs/toolkit";

const initialState: RootState["organisations"] = {
  organisations: []
};

const organisationSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {
    setOrganisationsList: (state, action) => {
      state.organisations = action.payload;
    }
  }
});

export const { setOrganisationsList } = organisationSlice.actions;

export default organisationSlice.reducer;
